import { isEmptyObject } from '@js/utils/toolbox';
import { reactive } from 'vue';

// Initial state
export const responseObjectInitial = () => ({
	uniqueTravelMethods: [],
	airportPriceMap: {},
	airportDetails: {},
	airlineDetails: {},
	uniquePrices: [],
	uniquePaymentMethods: [],
	uniqueTicketCategories: [],
	uniqueTicketFlexbilities: [],
	uniqueTransferTimes: [],
	uniqueAirportDepartures: [],
	uniqueAirportArrivals: [],
	uniqueProducers: {},
	uniqueAirportStops: [],
	uniqueNumStops: [],
	uniqueTimes: [],
	uniqueTimesOffset: [],
	searchParameters: {},
	uniqueMaxTraveltimePerTrip: [],
	uniqueWaittime: [],
	alliance: {},
	travelAgent: [],
	equipment: [],
	trips: {},
	segments: {},
	foreign: [],
	blacklistedAirlines: [],
	metaInfo: {
		resultCount: 'Admin please fix'
	}
});

// Reactive state
const state = reactive({
	response: responseObjectInitial()
});

// Mutations
const mutations = {
	set (payload) {
		if (isEmptyObject(payload)) {
			state.response = responseObjectInitial();
		} else {
			state.response = payload;
		}
	}
};

// Export a Composition API function to use the store
export const useResultQueryStore = () => ({
	state,
	...mutations
});
